import React, { Component } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import UpdateEmailModalUI from './UpdateEmailModalUI';

class UpdateEmailModalSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false,
      email: props.selectedEmail || '',
      emailError: null,
    };
  }

  render() {
    return (
      <UpdateEmailModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // Event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onUpdateEmailCancel}
        // Modes
        updateEmailMode={this.props.updateEmailMode}
        submitted={this.state.submitted}
        // Form fields
        email={this.state.email}
        onEmailChange={(event) => this.setState({ email: event.target.value })}
        emailError={this.state.emailError}
        setEmailError={(error) => this.setState({ emailError: error })}
      />
    );
  }

  componentDidMount() {
    Modal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedEmail !== this.props.selectedEmail) {
      this.setState({ email: this.props.selectedEmail || '' });
    }
  }

  onUpdateEmailCancel = () => {
    this.props.onUpdateEmailCancel();
  };

  onSubmit = () => {
    if (this.state.submitted) return;

    const { message, selectedEmail } = this.props;

    if (!message) {
      console.error('Error: message object is missing');
      alert('Error: message object is missing');
      return;
    }

    if (!message.messageApprovalId) {
      console.error('Error: Message Approval ID is missing');
      alert('Error: Message Approval ID is missing');
      return;
    }

    if (!selectedEmail) {
      console.error('Error: Selected Email is missing');
      alert('Error: Selected Email is missing');
      return;
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true,
    });

    RestApiUtils.put(
      this.props.context,
      `/api/su/messages/approvals/${message.messageApprovalId}/email/${selectedEmail}`,
      this.onSubmitCallback,
      { email: this.state.email }
    );
  };


  onSubmitCallback = (response) => {
    const errorList = (response && response.errorList)
      ? response.errorList.map((error) => error.message)
      : [];

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false,
    });

    if (errorList.length === 0) {
      setTimeout(() => {
        this.setState({ successMsg: null });
        this.props.onUpdateEmailCancel();
        this.props.onRefreshClick();
      }, 2000);
    }
  };

  setErrorList = (errorList) => {
    this.setState({ errorList });
  };
}

export default withRouter(UpdateEmailModalSF);
